import React, { useState } from 'react';
import logoPeople from '../../assets/icons/user.png';
import logoImage from '../../assets/icons/image.png';
import logoEmail from '../../assets/icons/email.png';
import logoPassword from '../../assets/icons/password.png';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';

const Register = () => {
  let history = useHistory();

  const [input, setInput] = useState({
    name: '',
    image_url: '',
    email: '',
    password: '',
  });

  const handleChange = (event) => {
    let { name, value } = event.target;

    setInput({ ...input, [name]: value });
  };

  const handleRegister = (event) => {
    event.preventDefault();

    let { name, image_url, email, password } = input;

    axios
      .post(`https://dev-example.sanbercloud.com/api/register`, {
        name,
        image_url,
        email,
        password,
      })
      .then(({ data }) => {
        let { token } = data;
        history.push('/login');
      })
      .catch((err) => {
        alert(err);
      });
  };

  return (
    <>
      <div className="flex justify-center items-center h-screen">
        <div className="flex flex-col w-full max-w-md px-4 py-8 bg-white rounded-lg shadow  sm:px-6 md:px-8 lg:px-10">
          <div className="self-center mb-6 text-xl font-light text-gray-600 sm:text-2xl ">
            Register
          </div>
          <div className="mt-8">
            <form onSubmit={handleRegister} autoComplete="off">
              <div className="flex flex-col mb-2">
                <div className="flex relative ">
                  <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                    <img
                      src={logoPeople}
                      width={15}
                      height={15}
                      alt="Logo-People"
                    />
                  </span>
                  <input
                    onChange={handleChange}
                    value={input.name}
                    name="name"
                    type="text"
                    className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                    placeholder="Your name"
                  />
                </div>
              </div>
              <div className="flex flex-col mb-2">
                <div className="flex relative ">
                  <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                    <img
                      src={logoImage}
                      width={15}
                      height={15}
                      alt="LogoImage"
                    />
                  </span>
                  <input
                    onChange={handleChange}
                    value={input.image_url}
                    name="image_url"
                    type="file"
                    className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                  />
                </div>
              </div>
              <div className="flex flex-col mb-2">
                <div className="flex relative ">
                  <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                    <img
                      src={logoEmail}
                      width={15}
                      height={15}
                      alt="logoEmail"
                    />
                  </span>
                  <input
                    onChange={handleChange}
                    value={input.email}
                    name="email"
                    type="text"
                    className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                    placeholder="Your email"
                  />
                </div>
              </div>
              <div className="flex flex-col mb-6">
                <div className="flex relative ">
                  <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                    <img
                      src={logoPassword}
                      width={15}
                      height={15}
                      alt="Logo Password"
                    />
                  </span>
                  <input
                    onChange={handleChange}
                    value={input.password}
                    name="password"
                    type="password"
                    className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                    placeholder="Your password"
                    minLength={8}
                  />
                </div>
              </div>
              <div className="flex items-center mb-6 -mt-4"></div>
              <div className="flex w-full">
                <button
                  type="submit"
                  className="py-2 px-4  bg-purple-600 hover:bg-purple-700 focus:ring-purple-500 focus:ring-offset-purple-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg "
                >
                  Register
                </button>
              </div>
            </form>
          </div>
          <div className="flex items-center justify-center mt-6">
            <Link
              to="/login"
              className="inline-flex items-center text-xs font-light text-center text-gray-500 hover:text-gray-700"
            >
              Do you have an account?
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
